import { render, staticRenderFns } from "./solicitation.vue?vue&type=template&id=65289f6c&scoped=true"
import script from "./solicitation.vue?vue&type=script&lang=js"
export * from "./solicitation.vue?vue&type=script&lang=js"
import style0 from "./solicitation.vue?vue&type=style&index=0&id=65289f6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65289f6c",
  null
  
)

export default component.exports